// Footer.js
import React from 'react';
import './Footer.module.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <center>Cập nhật lúc 26/04/2025 - Version 2.1.0</center>
      </div>
    </footer>
  );
};

export default Footer;
